import { ResponsiveBar } from "@nivo/bar";
import { ResponsiveLine } from "@nivo/line";
import React, { useMemo } from "react";


export const OverallLossPerTimestep = (props) => {
    const { overall = [] } = props;

    const chart = useMemo(() => Array.from({ length: 1000 }).map((_, idx) => ({ x: idx, y: overall[idx] == 0 ? null : overall[idx] })), [overall]);
    const bars = useMemo(() => Object.fromEntries(overall.map((e, idx) => ([`${idx}`, e]))), [overall]);
    // const barKeys = Object.keys(bars);
    const showBar = false;
    const ChartComponent = showBar ? ResponsiveBar : ResponsiveLine;
    const data = showBar ? [bars] : [{ id: "loss", data: chart }];

    return (<div>
        <div style={{ width: '100%', minHeight: 200, height: 200 }}>
            <ChartComponent
                data={data}
                // keys={showBar ? barKeys : undefined}
                // indexBy={showBar ? "x" : undefined}
                margin={{ top: 10, right: 50, bottom: 30, left: 10 }}
                xScale={{ type: 'linear', }}
                yScale={{ type: 'linear' }}
                yFormat=" >-.6f"
                enableSlices="x"
                curve="linear"
                axisTop={null}
                axisLeft={null}
                animate={false}
                axisRight={{
                    format: '.6f',
                    legendOffset: 0
                }}
                enableGridX={true}
                colors={{ scheme: 'tableau10' }}
                theme={{
                    "tooltip": {
                        "container": {
                            "color": "black"
                        }
                    },
                    "grid": {
                        "line": {
                            "stroke": "#777777"
                        }
                    },
                    "axis": {
                        "domain": {
                            "line": {
                                "stroke": "#777777",
                                "strokeWidth": 1
                            }
                        },
                        // "grid": 6,
                        "legend": {
                            "text": {
                                "fontSize": 12,
                                "fill": "#ff0000",
                                "outlineWidth": 0,
                                "outlineColor": "transparent"
                            }
                        },
                        "ticks": {
                            "text": {
                                "fontSize": 11,
                                "fill": "#c0c0c0",
                                "outlineWidth": 0,
                                "outlineColor": "transparent"
                            }
                        }
                    },
                }}
                lineWidth={1}
                enablePoints={false}
                crosshairType="cross"
                enableTouchCrosshair={true}
                useMesh={false}
                legends={[]} />
        </div>
    </div>);
};
